module.exports = __webpack_public_path__ + "img/bannner.c59f10de.jpg";